import React, { useEffect } from 'react'
import className from 'classnames/bind'
import { useHistory } from 'react-router'

import style from './MyhouseMainHouseRegistGuide.module.scss'

import { LAND_SERVICE_PREFIX_URL } from '@Root/contants/urlConstants'
import BlindContent from '@Components/atoms/BlindContent'
import IconCheck4x18 from '@Ui/images/myhouse/IconCheck4x18.svg'
import ImgRegisterGuide from '@Ui/images/myhouse/ImgRegisterGuide.svg'
import { handleNclick } from '@Helpers/nclick'
import { NCLICK, NDS_PROTOCOL } from '@Root/contants/lcs'
import { lcsSend } from '@Helpers/lcs'

const cx = className.bind(style)

const MyhouseMainHouseRegistGuide: React.FC = () => {
  const history = useHistory()

  const onClickAddHouse = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()
    handleNclick(NCLICK.MY_HOUSE.NO_HOME_GUIDE.ADD, event)

    history.push(`${LAND_SERVICE_PREFIX_URL.MYHOUSE_REGISTER}/address`)
  }

  useEffect(() => {
    lcsSend(NDS_PROTOCOL.MY_HOUSE.HOME.NO_HOME_GUIDE)
  }, [])

  return (
    <section id="content" className={cx('article')} role="main">
      <BlindContent />
      <div className={cx('inner')}>
        <h3 className={cx('title')}>
          우리집을 등록하고
          <br />
          <em className={cx('emphasis')}>다양한 우리단지 정보</em>를 확인하세요
        </h3>
        <div className={cx('main_image')}>
          <ImgRegisterGuide />
        </div>
        <ul className={cx('list')}>
          <li className={cx('item')}>
            <IconCheck4x18 />
            최신시세, 실거래가, 매물정보
          </li>
          <li className={cx('item')}>
            <IconCheck4x18 />
            우리단지 공지사항
          </li>
          <li className={cx('item')}>
            <IconCheck4x18 />
            입주민들의 생생한 리뷰
          </li>
          <li className={cx('item')}>
            <IconCheck4x18 />
            알림 관리(신규매물, 실거래가, 공지사항 등)
          </li>
        </ul>
        <a href="#" className={cx('link_register')} aria-label="추가" role="button" onClick={(e) => onClickAddHouse(e)}>
          우리집 등록하기
        </a>
      </div>
    </section>
  )
}

export default MyhouseMainHouseRegistGuide
